import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ActionCreators } from '@redux-devtools/core';
import LogMonitorButton from './LogMonitorButton';
// eslint-disable-next-line @typescript-eslint/unbound-method
var reset = ActionCreators.reset,
    rollback = ActionCreators.rollback,
    commit = ActionCreators.commit,
    sweep = ActionCreators.sweep;
var style = {
  textAlign: 'center',
  borderBottomWidth: 1,
  borderBottomStyle: 'solid',
  borderColor: 'transparent',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'row'
};

var LogMonitorButtonBar = /*#__PURE__*/function (_PureComponent) {
  _inherits(LogMonitorButtonBar, _PureComponent);

  var _super = _createSuper(LogMonitorButtonBar);

  function LogMonitorButtonBar() {
    var _this;

    _classCallCheck(this, LogMonitorButtonBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleRollback", function () {
      _this.props.dispatch(rollback());
    });

    _defineProperty(_assertThisInitialized(_this), "handleSweep", function () {
      _this.props.dispatch(sweep());
    });

    _defineProperty(_assertThisInitialized(_this), "handleCommit", function () {
      _this.props.dispatch(commit());
    });

    _defineProperty(_assertThisInitialized(_this), "handleReset", function () {
      _this.props.dispatch(reset());
    });

    return _this;
  }

  _createClass(LogMonitorButtonBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          hasStates = _this$props.hasStates,
          hasSkippedActions = _this$props.hasSkippedActions;
      return /*#__PURE__*/React.createElement("div", {
        style: _objectSpread(_objectSpread({}, style), {}, {
          borderColor: theme.base02
        })
      }, /*#__PURE__*/React.createElement(LogMonitorButton, {
        theme: theme,
        onClick: this.handleReset,
        enabled: true
      }, "Reset"), /*#__PURE__*/React.createElement(LogMonitorButton, {
        theme: theme,
        onClick: this.handleRollback,
        enabled: hasStates
      }, "Revert"), /*#__PURE__*/React.createElement(LogMonitorButton, {
        theme: theme,
        onClick: this.handleSweep,
        enabled: hasSkippedActions
      }, "Sweep"), /*#__PURE__*/React.createElement(LogMonitorButton, {
        theme: theme,
        onClick: this.handleCommit,
        enabled: hasStates
      }, "Commit"));
    }
  }]);

  return LogMonitorButtonBar;
}(PureComponent);

_defineProperty(LogMonitorButtonBar, "propTypes", {
  dispatch: PropTypes.func,
  theme: PropTypes.object
});

export { LogMonitorButtonBar as default };